/**
 * @Description 定义本地路由文件
 * @author 滕威
 * @time 2019-12-02
 */
// 公共路由
export const constantRouterMap = [
  // 直接发包cms一览
  {
    path: "/",
    name: "contractRecordDirectlyCms",
    component: () =>
      import("../views/page/cms/contractRecordDirectly/index.vue")
  },
  // 直接发包cms详情
  {
    path: "/contractRecordDirectlyDetailCms",
    name: "contractRecordDirectlyDetailCms",
    component: () =>
      import("../views/page/cms/contractRecordDirectly/details/index.vue")
  },
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("../views/sys/login/index.vue")
  },
  // 监管人员登录
  {
    path: "/workerLogin",
    name: "workerLogin",
    component: () => import("../views/sys/workerLogin/index.vue")
  },
  // 忘记密码
  {
    path: "/forgetThePassword",
    name: "forgetThePassword",
    component: () => import("../views/sys/forgetThePassword/index.vue")
  },
  // 注册
  {
    path: "/register",
    name: "register",
    component: () => import("../views/sys/register/index.vue")
  },
  // cms下载中心路由
  {
    path: "/cmsDownloadCenter",
    name: "cmsDownloadCenter",
    component: () => import("../views/page/cms/downloadCenter/index.vue")
  },
  // 直接发包备案报表
  {
    path: "/contractRecordDirectlyReportView",
    name: "contractRecordDirectlyReportView",
    component: () =>
      import(
        "../views/page/reportView/contractRecordDirectlyReportView/index.vue"
      )
  }
];

// 监管人员路由
export const supervisionRouteMap = [
  // 监管人员 - 工作台
  {
    path: "/staffWorkbench",
    name: "staffWorkbench",
    component: () => import("../views/page/staffPage/staffWorkbench/index.vue")
  },
  // 监管人员 - 历史核验一览
  {
    path: "/staffHistoricalVerification",
    name: "staffHistoricalVerification",
    component: () =>
      import(
        "../views/page/staffPage/components/historicalVerification/index.vue"
      )
  },
  // 监管人员 - 项目登记核验一览
  {
    path: "/supConstructionAudit",
    name: "supConstructionAudit",
    component: () =>
      import("../views/page/staffPage/supConstructionAudit/index.vue")
  },
  // 监管人员 - 项目登记核验详情
  {
    path: "/supConstructionAuditDetail",
    name: "supConstructionAuditDetail",
    component: () =>
      import("../views/page/staffPage/supConstructionAudit/details/index.vue")
  },
  // 监管人员 - 项目登记核验一览
  {
    path: "/constructionAudit",
    name: "constructionAudit",
    component: () =>
      import("../views/page/staffPage/constructionAudit/index.vue")
  },
  // 监管人员 - 项目登记核验详情
  {
    path: "/constructionAuditDetail",
    name: "constructionAuditDetail",
    component: () =>
      import("../views/page/staffPage/constructionAudit/details/index.vue")
  },
  // 监管人员 - 直接发包核验一览
  {
    path: "/contractRecordDirectlyAudit",
    name: "contractRecordDirectlyAudit",
    component: () =>
      import("../views/page/staffPage/contractRecordDirectlyAudit/index.vue")
  },
  // 监管人员 - 直接发包核验详情
  {
    path: "/contractRecordDirectlyAuditDetail",
    name: "contractRecordDirectlyAuditDetail",
    component: () =>
      import(
        "../views/page/staffPage/contractRecordDirectlyAudit/details/index.vue"
      )
  },
  // 监管人员 - 项目经理总监表解锁申请一览
  {
    path: "/projectManagerUnlockAudit",
    name: "projectManagerUnlockAudit",
    component: () =>
      import("../views/page/staffPage/projectManagerUnlockAudit/index.vue")
  },
  // 监管人员 - 项目经理总监表解锁申请详情
  {
    path: "/projectManagerUnlockAuditDetail",
    name: "projectManagerUnlockAuditDetail",
    component: () =>
      import(
        "../views/page/staffPage/projectManagerUnlockAudit/details/index.vue"
      )
  },
  // 监管人员 - 项目经理总监表变更申请一览
  {
    path: "/projectManagerChangeAudit",
    name: "projectManagerChangeAudit",
    component: () =>
      import("../views/page/staffPage/projectManagerChangeAudit/index.vue")
  },
  // 监管人员 - 项目经理总监表变更申请详情
  {
    path: "/projectManagerChangeAuditDetail",
    name: "projectManagerChangeAuditDetail",
    component: () =>
      import(
        "../views/page/staffPage/projectManagerChangeAudit/details/index.vue"
      )
  },
  // 监管人员 - 直接发包项目经理总监表解锁申请一览
  {
    path: "/contractProjectManagerUnlockAudit",
    name: "contractProjectManagerUnlockAudit",
    component: () =>
      import(
        "../views/page/staffPage/contractProjectManagerUnlockAudit/index.vue"
      )
  },
  // 监管人员 - 直接发包项目经理总监表解锁申请详情
  {
    path: "/contractProjectManagerUnlockAuditDetail",
    name: "contractProjectManagerUnlockAuditDetail",
    component: () =>
      import(
        "../views/page/staffPage/contractProjectManagerUnlockAudit/details/index.vue"
      )
  },
  // 监管人员 - 直接发包项目经理总监表变更申请一览
  {
    path: "/contractProjectManagerChangeAudit",
    name: "contractProjectManagerChangeAudit",
    component: () =>
      import(
        "../views/page/staffPage/contractProjectManagerChangeAudit/index.vue"
      )
  },
  // 监管人员 - 直接发包项目经理总监表变更申请详情
  {
    path: "/contractProjectManagerChangeAuditDetail",
    name: "contractProjectManagerChangeAuditDetail",
    component: () =>
      import(
        "../views/page/staffPage/contractProjectManagerChangeAudit/details/index.vue"
      )
  },
  // 监管人员 - 项目数据统计
  {
    path: "/projectDataStatistics",
    name: "projectDataStatistics",
    component: () =>
      import("../views/page/staffPage/projectDataStatistics/index.vue")
  }
];
